import FormattedMessage from 'I18n/components/FormattedMessage';
import { CUIHeading } from 'connect-dot-com-ui-components/Components/CUIHeading/CUIHeading';
import { CUIModal, CUIModalOverlay, CUIModalContent, CUIModalHeader, CUIModalCloseButton, CUIModalBody, CUIModalFooter } from 'connect-dot-com-ui-components/Components/CUIModal/CUIModal';
import DownloadAppContent from './DownloadAppContent';
import CUIButton from 'connect-dot-com-ui-components/Components/CUIButton/CUIButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const DownloadAppModal = ({
  onClose,
  isOpen,
  qrCodeSrc,
  appStoreCampaign
}) => {
  return /*#__PURE__*/_jsxs(CUIModal, {
    onClose: onClose,
    isOpen: isOpen,
    children: [/*#__PURE__*/_jsx(CUIModalOverlay, {}), /*#__PURE__*/_jsxs(CUIModalContent, {
      "data-test-id": "qr-code-modal",
      minW: "750px",
      px: 6,
      children: [/*#__PURE__*/_jsxs(CUIModalHeader, {
        px: 0,
        children: [/*#__PURE__*/_jsx(CUIHeading, {
          as: "h3",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "app.Banners.downloadApp.modal.heading"
          })
        }), /*#__PURE__*/_jsx(CUIModalCloseButton, {})]
      }), /*#__PURE__*/_jsx(CUIModalBody, {
        px: 0,
        children: /*#__PURE__*/_jsx(DownloadAppContent, {
          appStoreCampaign: appStoreCampaign,
          qrCodeSrc: qrCodeSrc
        })
      }), /*#__PURE__*/_jsx(CUIModalFooter, {
        borderTopStyle: "solid",
        borderTopWidth: "1px",
        px: 0,
        pb: 6,
        children: /*#__PURE__*/_jsx(CUIButton, {
          onClick: onClose,
          variant: "primary",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "app.Banners.downloadApp.modal.closeButton"
          })
        })
      })]
    })]
  });
};